import { useTranslation } from 'react-i18next';
import CloseCircleIcon from '@/public/icons/approval/close-circle.svg';
import { formatApprovalDate } from '@/utils/approval/formatApprovalDate';
import RelatedItemRow from './RelatedItemRow';
import { RoundedIconButton, SelectedRowChrome } from './styles';
import type { RelatedApprovalItem } from './types';

type SelectedItemProps = {
  item: RelatedApprovalItem;
  onRemove: (docId: string) => void;
};

const SelectedItem = ({ item, onRemove }: SelectedItemProps) => {
  const { t } = useTranslation();
  return (
    <RelatedItemRow
      rootComponent={SelectedRowChrome}
      title={item.subject}
      titleTone="plain"
      status={item.status}
      author={item.author.name}
      date={formatApprovalDate(item.authoredAt) ?? t('날짜 없음')}
      trailing={
        <RoundedIconButton
          type="button"
          aria-label={t('선택 해제')}
          onClick={() => onRemove(item.docId)}
        >
          <CloseCircleIcon width={18} height={18} />
        </RoundedIconButton>
      }
    />
  );
};

export default SelectedItem;
